import { defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { useDuck } from '~/services';
import { cachePage, createHead, pluralize } from '~/utils';
import { PODCASTS_PARTNERS } from '~/components/PodcastPartner';
const duck = useDuck();
export default defineComponent({
    name: 'PagePodcasts',
    setup() {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        return {
            css,
        };
    },
    async asyncData(context) {
        const { app, env, error, req, res, route, query } = context;
        try {
            let { data = [] } = await duck.pub.getPubPodcasts();
            if ('serials' in query) {
                const serials = query.serials.split(',');
                data = data.filter(({ url_alias: url }) => serials.includes(url.replace('podcasts/', '')));
            }
            const podcasts = data.map((podcast) => {
                const items = podcast.articles || [];
                const podcasts = items
                    .map((item) => {
                    return {
                        date: Number(item.time) * 1000,
                        description: item.subtitle,
                        file: item.podcast_file,
                        isPartner: `${podcast.url}` in PODCASTS_PARTNERS(),
                        key: item.issue || 0,
                        serial: item.serial || {},
                        title: item.title,
                        url: `/${item.url_alias}`,
                    };
                })
                    .slice(0, 2);
                return {
                    description: podcast.fields?.field_subtitle?.value || '',
                    image: podcast.fields?.field_main_image?.value,
                    isPartner: `${podcast.url}` in PODCASTS_PARTNERS(),
                    podcasts,
                    size: podcasts?.[0]?.key ? pluralize(podcasts[0].key, 'выпуск', 'выпуска', 'выпусков', true) : '',
                    title: podcast.name,
                    url: `/${podcast.url}`,
                };
            });
            const title = 'Подкасты';
            const head = {
                canonical: env.HOST + route.path,
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            if (process.server) {
                const [firstPodcast] = podcasts[0]?.podcasts;
                if (firstPodcast) {
                    cachePage({ date: firstPodcast.date, req, res });
                }
            }
            return {
                $page: context.$page,
                head,
                podcasts,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
